module.exports = require("./fr-WF");